import React from 'react';
import { useSelector } from 'react-redux';

import CrmIframe from '@swf/components/CrmZone/components/CrmIframe/CrmIframe';
import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import { select } from '@swf/core/store';
import type { WidgetFC } from '@swf/core/types/Widget';

import NoPromotionMessage from './components/NoPromotionMessage';
import { sportsPromotionDetailsWidgetModel, useSportsPromotionDetailsWidget } from './model';

const SportsPromotionDetailsWidget: WidgetFC = () => {
  const { widgetSelect } = useSportsPromotionDetailsWidget();

  const promotion = useSelector(widgetSelect.promotion);
  const hasErrored = useSelector(widgetSelect.hasErrored);
  const isLoading = useSelector(widgetSelect.isLoading);
  const hasPreloaded = useSelector(widgetSelect.hasPreloaded);
  const isPromotionNotFound = useSelector(widgetSelect.promotionNotFound);
  const isAuthCheckComplete = useSelector(select.session.isAuthenticationCheckComplete);

  if ((isLoading && !hasPreloaded) || hasErrored) return null;
  if (!isLoading && isAuthCheckComplete && isPromotionNotFound) return <NoPromotionMessage />;
  if (!promotion) return null;

  return <CrmIframe html={promotion} dynamicHeight data-testid="crm-sports-promotion" />;
};

SportsPromotionDetailsWidget.model = sportsPromotionDetailsWidgetModel;

export default withWidgetTestId(SportsPromotionDetailsWidget, 'sports-promotion-details');
